var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import "./Picker.types";
export var getSelectedItem = function (selection, selectedId) {
    var all = selection.all;
    for (var i = 0; i < all.items.length; i += 1) {
        var item = all.items[i];
        if (item.id === selectedId)
            return item;
    }
    return null;
};
export var prepareSelectionItems = function (items, selectedId, exclude) {
    if (exclude) {
        return items.filter(function (item) { return item.id !== selectedId; });
    }
    return __spreadArray([], items, true).sort(function (item) { return (item.id === selectedId ? -1 : 1); });
};
export var constructPickerRows = function (items) {
    var columnsCount = 4;
    var rows = [];
    for (var i = 0; i < items.length; i += columnsCount) {
        rows.push(items.slice(i, i + columnsCount));
    }
    return rows;
};
